<template>
    <div class="login_form">
        <div v-if="emailSent">
            <div class="text_wrapper">
                An email has been sent. Please check for an email from company
                and click on the included link to reset your password.
            </div>
            <div class="form_btn">
                <nuxt-link
                    to="/login"
                    class="btn btn_brand"
                    style="border-radius: 0"
                >
                    Back to login
                </nuxt-link>
            </div>
        </div>

        <div v-else>
            <div class="text_wrapper">
                Enter your email address and we'll send you an email with
                instructions to reset your password.
            </div>
            <form @submit.prevent="sendLink">
                <div class="form_row_wrapper">
                    <div class="form_row">
                        <div class="label">
                            Email
                        </div>
                        <input
                            v-model="email"
                            class="form_control"
                            type="email"
                            autocomplete="off"
                            required
                        />
                    </div>
                </div>
                <div v-if="emailError" class="error-wrapper">
                    Please insert valid email address
                </div>
                <div class="form_btn">
                    <input
                        class="btn btn_brand"
                        type="submit"
                        value="SEND RESET PASSSWORD LINK"
                    />
                </div>
            </form>
            <div class="account_control">
                <div class="control_row">
                    Already have an account?
                    <nuxt-link to="/login">
                        Log in
                    </nuxt-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

export default {
    layout: 'login',

    validations: {
        email: { required, email }
    },

    data() {
        return {
            email: '',
            emailSent: false
        };
    },

    head() {
        return {
            title: 'Forget Password | Unique Technologies'
        };
    },

    computed: {
        emailError() {
            return this.$v && this.$v.email.$error;
        }
    },

    methods: {
        ...mapActions({
            sendResetPasswordLink: 'account/sendResetPasswordLink'
        }),

        async sendLink() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.sendResetPasswordLink(this.email);

                this.email = '';
                this.emailSent = true;
            } catch (error) {
                console.error(error);

                this.$sentry.captureException(error);
            }
        }
    }
};
</script>
